import { PortalCard, Skeleton, SkeletonGroup, SkeletonText } from './portal';

/**
 * Suspense fallback for lazy route chunks. Mirrors a `PortalPage`: the same
 * column/padding, a 32px icon + 40px title header row, then one card.
 */
export function DashboardLoadingState() {
  return (
    <div className="flex h-full flex-col overflow-y-auto">
      <SkeletonGroup
        label="Loading page"
        className="mx-auto flex w-full max-w-[1432px] flex-1 flex-col gap-10 px-5 py-8 sm:px-8 lg:px-16 lg:py-16"
      >
        <div className="flex h-10 items-center gap-3">
          <Skeleton className="size-8 shrink-0" rounded="lg" />
          <Skeleton className="h-8 w-56" rounded="lg" />
        </div>
        <PortalCard className="flex w-full max-w-[640px] flex-col gap-6 p-6 sm:p-8">
          <SkeletonText lines={3} />
        </PortalCard>
      </SkeletonGroup>
    </div>
  );
}
